import { render, staticRenderFns } from "./InvoicesTableMobile.vue?vue&type=template&id=4b8a10b2&scoped=true"
import script from "./InvoicesTableMobile.vue?vue&type=script&lang=js"
export * from "./InvoicesTableMobile.vue?vue&type=script&lang=js"
import style0 from "./InvoicesTableMobile.vue?vue&type=style&index=0&id=4b8a10b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a10b2",
  null
  
)

export default component.exports